/* eslint-disable no-undef */
import { FunctionComponent } from 'react';
import CourseLanding from './../../components/courseLanding';
import SectionTitle from './../../components/sectionTitle';
import Conversation from './conversation';
import Quiz from './../../components/quiz';
import Animation002 from './animation002';
import Animation006 from './animation006';
import Animation011 from './animation011';
import Animation020 from './animation020';
import Animation021 from './animation021';
import Animation022 from './animation022';
import Animation025 from './animation025';
import Animation028 from './animation028';
import Animation032 from './animation032';
import Animation033 from './animation033';
import Animation034 from './animation034';
import Animation035 from './animation035';
import Animation036 from './animation036';
import Animation037 from './animation037';
import Animation038 from './animation038';
import Component001 from './component001';
import Component002 from './component002';
import Component003 from './component003';
import Component004 from './component004';
import Component005 from './component005';
import Component008 from './component008';
import Animation039 from './animation039';

const Components: {
  [key: string]: FunctionComponent<any>;
} = {
  Quiz,
  CourseLanding,
  SectionTitle,
  Conversation,
  Animation002,
  Animation006,
  Animation011,
  Animation020,
  Animation021,
  Animation022,
  Animation025,
  Animation028,
  Animation032,
  Animation033,
  Animation034,
  Animation035,
  Animation036,
  Animation037,
  Animation038,
  Animation039,
  Component001,
  Component002,
  Component003,
  Component004,
  Component005,
  Component008,
};

export default Components;
